import moment from "moment";
import React, { Component } from "react";
import "react-block-ui/style.css";
import { Link } from "react-router-dom";
import LoadingIndicator from "../Components/LoadingIndicator/LoadingIndicator";
import Pagination from "../Shared/pagination";
import ReportsService from "../utils/ReportsService";

const StatTable = props => {
  const { title, data } = props;

  const rows = data.map((value, index) => (
    <tr key={index}>
      <td>
        <Link to={`/m1/deals/${value["id"]}`}>Deal #{value["id"]}</Link>
      </td>
      <td>
        {moment(value["tcs_at"])
          .tz("Australia/Sydney")
          .format("dddd Do MMM, h:mma")}
      </td>
      <td>
        {value["dead_deal_reasons"]
          .split("_")
          .map(word => word[0].toUpperCase() + word.slice(1))
          .join(" ")}
      </td>
      <td>{value["dead_deal_descriptions"]}</td>
    </tr>
  ));
  return (
    <div
      style={{
        padding: 20,
        margin: 10,
        background: "#fefefe",
        border: "1px solid #ccc"
      }}
    >
      <h4 style={{ marginTop: 0 }}>{title}</h4>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Id</th>
            <th>TCS At</th>
            <th>Dead Deal Reason</th>
            <th>Comment</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
};

class ReportingDeadDeals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      currentPage: 1,
      totalPages: 1,
      per: 50
    };
  }

  onPageChange = currentPage => {
    this.setState({ currentPage: currentPage }, () => this.fetchItems());
  };

  componentDidMount() {
    this.setState({ loadingInProgress: true }, () => {
      this.fetchItems();
    });
  }

  fetchItems() {
    this.setState({ loadingInProgress: true });
    ReportsService.deadDeals({
      page: this.state.currentPage,
      per: this.state.per
    }).then(data => {
      this.setState({
        loadingInProgress: false,
        data: data,
        totalPages: data.total_pages || 1
      });
    });
  }

  render() {
    if (!this.state.data) return null;

    return (
      <div>
        <LoadingIndicator loadingInProgress={this.state.loadingInProgress}>
          {this.state.totalPages > 1 && (
            <Pagination
              currentPage={this.state.currentPage}
              totalPages={this.state.totalPages}
              onChange={this.onPageChange}
            />
          )}
          <StatTable
            title="Dead Deals Reporting"
            data={this.state.data.results}
          ></StatTable>
        </LoadingIndicator>
      </div>
    );
  }
}
export default ReportingDeadDeals;
